<template>
    <div>
        <div class="grid grid-cols-12 gap-6 border-b-1 pb-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/historie-ulic-do-roku-1900"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/historie_ulic_do_roku_1900.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/historie-ulic-do-roku-1900"
                        class="underline"
                    >
                        Historie ulic do roku 1900
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Jak vznikala jména pražských ulic? Tento poutavý text
                    provádí čtenáře vývojem uliční sítě Prahy od nejstarších
                    stezek směřujících k brodům, přes středověké zakládání měst,
                    barokní přestavby i jazykové zápasy 19. století...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/historie-ulic-do-roku-1900"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/historie-ulic-1900-1989"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/historie_ulic_1900_1989.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/historie-ulic-1900-1989"
                        class="underline"
                    >
                        Historie ulic 1900–1989
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Vývoj pražského uličního názvosloví od začátku 20. století
                    do konce osmdesátých let je fascinujícím příběhem, který
                    zdaleka neodráží jen změny mapy, ale i hlubší společenské a
                    politické otřesy...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/historie-ulic-1900-1989"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/historie-ulic-po-roce-1989"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/historie_ulic_po_roce_1989.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/historie-ulic-po-roce-1989"
                        class="underline"
                    >
                        Historie ulic po roce 1989
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Jak se přepisují dějiny v uličním názvosloví Prahy?
                    <br />Článek mapuje vývoj pojmenovávání pražských ulic od
                    roku 1989. Ukazuje, že ani jména ulic nejsou vůči dějinám
                    imunní — za každým z nich ...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/historie-ulic-po-roce-1989"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/lokalni-nazvoslovne-systemy"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/lokalni_nazvoslovne_systemy.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/lokalni-nazvoslovne-systemy"
                        class="underline"
                    >
                        Lokální názvoslovné systémy
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Lokální systémy pojmenování ulic vznikly v Praze v 19.
                    století. Obliba pojmenovávat sousední ulice v jedné oblasti
                    podle souvisejících událostí, osobností, obcí, rostlin či v
                    místě obvyklých názvů přetrvává v hlavním městě dodnes....
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/lokalni-nazvoslovne-systemy"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/pocty-ulic"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/pocty_ulic.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/pocty-ulic"
                        class="underline"
                    >
                        Počty ulic
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Přehled vývoje počtu pražských ulic od středověku po
                    současnost, včetně důvodů, proč je jejich přesné určení
                    problematické. Text doplňují aktuální statistiky a srovnání
                    s jinými městy...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/pocty-ulic"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/vyvoj-oznaceni-ulic-v-terenu"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/vyvoj_oznaceni_ulic_v_terenu_1.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/vyvoj-oznaceni-ulic-v-terenu"
                        class="underline"
                    >
                        Vývoj označení ulic v terénu
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Jak se v Praze měnily uliční tabulky? <br />Od malovaných
                    nápisů na zdi přes smaltované cedule až po moderní design –
                    označování pražských ulic má za sebou dlouhý vývoj. Tento
                    článek vás provede základními proměnami...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/vyvoj-oznaceni-ulic-v-terenu"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/pravopis-a-jazykova-spravnost-nazvu"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/pravopis_a_jazykova_spravnost_nazvu.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/pravopis-a-jazykova-spravnost-nazvu"
                        class="underline"
                    >
                        Pravopis a jazyková správnost názvů
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Pojmenovávání veřejných prostranství není jen otázkou
                    kreativity, ale i jazykové správnosti. Zajímá vás, proč je
                    „Machnova“ špatně, nebo zda psát „U Komína“ či „U komína“?
                    Odpovědi najdete právě zde...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/pravopis-a-jazykova-spravnost-nazvu"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/prejmenovavani"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/prejmenovavani.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/prejmenovavani"
                        class="underline"
                    >
                        Přejmenovávání
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    K přejmenovávání ulic v minulosti docházelo zejména se
                    změnou jejich účelu nebo spojením s jinou komunikací.
                    Některé pražské ulice během staletí vystřídaly i deset
                    různých názvů, jiné si ten svůj drží už od středověku...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/prejmenovavani"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/puvody-nazvu-a-jech-cetnost"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/puvody_nazvu_a_jejich_cetnost.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/puvody-nazvu-a-jech-cetnost"
                        class="underline"
                    >
                        Původy názvů a jejich četnost
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Proč se pražské ulice jmenují právě tak, jak se jmenují?
                    Článek odhaluje nejčastější typy názvů – od těch podle
                    polohy, osobností či měst až po zapomenuté pomístní názvy –
                    a přináší zajímavosti o tom, kdo nebo co se do pražské mapy
                    zapsalo nejčastěji.
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/puvody-nazvu-a-jech-cetnost"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
